import { PushMfaVerificationState } from '@pages/push-mfa-verification/store/state/push-mfa-verification.state';

export const pushMfaVerificationState = [PushMfaVerificationState];
